import { Action } from "redux";
import { EVENT_ACTION, EventData } from '../interface';

export interface ActionWithPayload extends Action {
    type: string;
    payload: {
        events: EventData[],
        currentPage: number,
        numberOfPages: number,
        event: EventData
    };
}


export default function event_reducer(eventsState: { isLoading: Boolean, numberOfPages: number, currentPage: number, events: EventData[], event: EventData } =
    {
        isLoading: true,
        numberOfPages: 0,
        currentPage: 0, events: [],
        event: { title: "", message: "", tags: [], selectedFile: "", likeCount: [], approved:false, finished:false, actionRequired:false }
    },
    action: ActionWithPayload) {
    switch (action.type) {
        case EVENT_ACTION.START_LOADING:
            return { ...eventsState, isLoading: true };
        case EVENT_ACTION.END_LOADING:
            return { ...eventsState, isLoading: false };
        case EVENT_ACTION.CREATE:
            return { ...eventsState, events: [...eventsState.events, action.payload.event] };
        case EVENT_ACTION.FETCH_EVENT:
            return {
                ...eventsState,
                event: action.payload.event
            };
        case EVENT_ACTION.FETCH_ALL:
            return {
                ...eventsState,
                events: action.payload.events,
                currentPage: action.payload.currentPage,
                numberOfPages: action.payload.numberOfPages,
            };
        case EVENT_ACTION.FETCH_BY_SEARCH:
            return {
                ...eventsState,
                events: action.payload.events,
                currentPage: action.payload.currentPage,
                numberOfPages: action.payload.numberOfPages,
            };
        case EVENT_ACTION.UPDATE:
            //@ts-ignore
            return { ...eventsState, events: eventsState.posts.map((event) => (event._id === action.payload.event._id ? action.payload.event : event)) };
        // return posts.map((post) => post._id === action.payload._id ? action.payload : post);
        case EVENT_ACTION.LIKE:
            //@ts-ignore
            return { ...eventsState, events: eventsState.events.map((event) => (event._id === action.payload.event._id ? action.payload.event : event)) };

        case EVENT_ACTION.DELETE:
            //@ts-ignore
            return { ...eventsState, events: eventsState.events.filter((event) => event._id !== action.payload) };
        default:
            return eventsState;
    }
};